/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';

import { Row, Col, Card } from 'react-bootstrap';

export interface IEventCardProps {
  startDate?: string | any;
  endDate?: string | any;
  organizer?: string;
  organizerLink?: string;
  organizerPrefix?: string;
  location?: string;
  locationPrefix?: string;
  locationLink?: string;
  address?: string;
  addressPrefix?: string;
  addressLink?: string;
  onlyTime?: string;
  lastItem?: boolean;
}

export const EventCard = ({
  startDate,
  endDate,
  organizer,
  organizerLink,
  organizerPrefix,
  locationLink,
  locationPrefix,
  location,
  address,
  addressPrefix,
  onlyTime,
  lastItem,
}: IEventCardProps) => {
  const startDateTime = startDate
    ? moment(startDate)?.format('HH:mm A')
    : startDate;
  const startDateMonth = startDate
    ? moment(startDate)?.format('MMM')
    : startDate;
  const startDateDay = startDate ? moment(startDate)?.format('D') : startDate;
  const startDateYear = startDate
    ? moment(startDate)?.format('YYYY')
    : startDate;
  const startDateFormatted = startDate
    ? moment(startDate)?.format('ddd, D MMM YYYY HH:mm A')
    : startDate;
  const endDateFormatted = endDate
    ? moment(endDate)?.format('ddd, D MMM YYYY HH:mm A')
    : endDate;
  let eventDuration;
  if (startDateFormatted && endDateFormatted) {
    eventDuration = `${startDateFormatted} - ${endDateFormatted}`;
  }
  const rowClassName = lastItem ? '' : 'border-bottom pb-4 mb-4';
  const _renderCalendar = () => {
    if (startDateMonth && startDateDay) {
      return (
        <Col xs="auto" className="mb-3 mb-sm-0">
          <div className="calendar d-flex">
            <span className="calendar-month">{startDateMonth}</span>
            <span className="calendar-day py-2">{startDateDay}</span>
            {startDateYear && (
              <span style={{ fontSize: 10, padding: 5 }}>{startDateYear}</span>
            )}
          </div>
        </Col>
      );
    }
  };
  const _renderDescription = () => {
    return (
      <Col>
        <Card.Link as={Link} to={locationLink ?? '#'} className="mb-1">
          {location && (
            <>
              <span>
                {`${locationPrefix} `}
                <h5 className="mb-1">{location}</h5>
              </span>
            </>
          )}
        </Card.Link>
        {organizer && (
          <span>
            {`${organizerPrefix} `}
            <Card.Link href={organizerLink ?? '#'}>{organizer}</Card.Link>
          </span>
        )}

        <div className="small fw-bold">
          {onlyTime ? `Time: ${startDateTime}` : eventDuration}
        </div>
        {address && (
          <span className="small fw-bold">
            {`${addressPrefix} `}
            <Card.Link href={addressPrefix ?? '#'}>{address}</Card.Link>
          </span>
        )}
      </Col>
    );
  };

  return (
    <>
      <Row className={`align-items-center d-block d-sm-flex ${rowClassName}`}>
        {_renderCalendar()}
        {_renderDescription()}
      </Row>
    </>
  );
};

EventCard.defaultProps = {
  organizerPrefix: 'Organized by',
  locationPrefix: '',
  addressPrefix: 'Place: ',
};
